// Amazon連携（LWA）未連携をバックエンドが返すときの機械可読コード。
// backend の respondIfLWANotConnected と対応。
export const LWA_NOT_CONNECTED_CODE = "LWA_NOT_CONNECTED";

// APIエラー（axios経由）が「未連携」かどうかを判定する。
// common.ts の axiosFetch は throw {status, response} 形式で投げ、
// response.data にサーバーのJSONボディ（code含む）が入る。
export const isLwaNotConnectedError = (err: any): boolean =>
  err?.response?.data?.code === LWA_NOT_CONNECTED_CODE ||
  err?.response?.status === 409 &&
    err?.response?.data?.code === LWA_NOT_CONNECTED_CODE;

// 未連携メッセージ。対象ユーザー名が分かる場合は「本人に連携を依頼」する文面にする。
// （オーナー/管理者が他ユーザーのプランを操作するケースが多いため、
// 　「自分で連携して」ではなく「その人に依頼して」が適切）
export const lwaNotConnectedMessage = (userName?: string): string =>
  userName
    ? `${userName}さんがAmazonと連携されていないため、この操作はできません。\n${userName}さんにAmazon連携（ユーザー情報画面）を依頼してください。`
    : "Amazonと連携されていないため、この操作はできません。\nユーザー情報画面からAmazon連携を行ってください。";
